import { Link } from 'react-router-dom';
import { File as FileIcon, FileText } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { useFilePreview } from '../panel/useFilePreview';
import { linkedChipClass } from '../../ui-components/linkedItemStyles';
import { LinkedFileDTO, LinkedPolicyDTO } from '../../../services/apiService';

const chipClass = cn(linkedChipClass, 'max-w-[15rem]');

export function PolicyChip({
    policy,
    interactive = true,
}: {
    policy: LinkedPolicyDTO;
    interactive?: boolean;
}) {
    const title = policy.document_id?.title?.trim();
    const content = (
        <>
            <FileText
                className="h-3 w-3 shrink-0 text-subtle-foreground"
                aria-hidden="true"
            />
            <span className={cn('truncate', interactive && 'text-blue')}>
                {title}
            </span>
        </>
    );

    if (!interactive) {
        return (
            <span title={title} className={chipClass}>
                {content}
            </span>
        );
    }

    return (
        <Link
            to={`/department-policies/${policy._id}`}
            title={title}
            className={chipClass}
        >
            {content}
        </Link>
    );
}

export function FileChip({
    file,
    interactive = true,
}: {
    file: LinkedFileDTO;
    interactive?: boolean;
}) {
    const { open, opening, modal } = useFilePreview(file);
    const content = (
        <>
            <FileIcon
                className="h-3 w-3 shrink-0 text-subtle-foreground"
                aria-hidden="true"
            />
            <span className={cn('truncate', interactive && 'text-blue')}>
                {file.filename}
            </span>
        </>
    );

    if (!interactive) {
        return (
            <span title={file.filename} className={chipClass}>
                {content}
            </span>
        );
    }

    return (
        <>
            <button
                type="button"
                title={file.filename}
                className={chipClass}
                disabled={opening}
                onClick={open}
            >
                {content}
            </button>
            {modal}
        </>
    );
}
